const card = "_275c1p2rphr";
const graphic = "_275gu0ovs7";
const publisher = "_275pgvr0jl";
const textContainer = "_275t1lpp36z";
const heading = "_275h1muli6b";
const subheading = "_275s1xg1um6";
const link = "_275lfqzjfz";
const linkIcon = "_275l1376qqk";
const throbber = "_275tny7gpa";
const chevron = "_275ces3x9a";

export { card, chevron, graphic, heading, link, linkIcon, publisher, subheading, textContainer, throbber };
import "./_location-card.style.linaria.module.css";
//# sourceMappingURL=_location-card.style.js.map
